<div class="main-wrapper home-page5">
    <router-outlet></router-outlet>
    <app-toast></app-toast>
    <div id="universal_loader">
        <div class="loader-wrapper">
            <div class="lds-roller">
                <div *ngFor="let x of [1,2,3,4,5,6,7,8]"></div>
            </div>
        </div>
    </div>
</div>
<app-float-button></app-float-button>